import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "uncat-left" };
const _hoisted_2 = { class: "uncat-avatar" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "uncat-text" };
const _hoisted_5 = { class: "uncat-title" };
const _hoisted_6 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'UncategorisedCard',
    props: {
        count: {}
    },
    emits: ["click"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "uncat-card",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                            src: require('@/assets/transactions/uncategorised.png'),
                            alt: ""
                        }, null, 8, _hoisted_3)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.count) + " uncategorised transaction" + _toDisplayString(_ctx.count === 1 ? '' : 's'), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "uncat-subtitle" }, "Tag them now for a more complete view", -1))
                    ])
                ]),
                _createElementVNode("img", {
                    class: "uncat-arrow",
                    src: require('@/assets/arrow-right.png'),
                    alt: ""
                }, null, 8, _hoisted_6)
            ]));
        };
    }
});
